var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 18.1818H12.4444V16.3636H10.6667V18.1818ZM14.2222 7.27273H16V5.45455H14.2222V7.27273ZM0 3.63636V16.3636C0 17.3636 0.8 18.1818 1.77778 18.1818H5.33333V16.3636H1.77778V3.63636H5.33333V1.81818H1.77778C0.8 1.81818 0 2.63636 0 3.63636ZM14.2222 1.81818V3.63636H16C16 2.63636 15.2 1.81818 14.2222 1.81818ZM7.11111 20H8.88889V0H7.11111V20ZM14.2222 14.5455H16V12.7273H14.2222V14.5455ZM10.6667 3.63636H12.4444V1.81818H10.6667V3.63636ZM14.2222 10.9091H16V9.09091H14.2222V10.9091ZM14.2222 18.1818C15.2 18.1818 16 17.3636 16 16.3636H14.2222V18.1818Z",
    fill: "#0096D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertical);
export default __webpack_public_path__ + "static/media/vertical.888ae3ee988b44c9bac7c679f275fbdb.svg";
export { ForwardRef as ReactComponent };